<template minapp='mpx' xlang='wxml'>
  <view class='es-credentials' wx:ref='abc'>
    <!-- 证件类型 -->
    <es-cell border useTitle custom-class="es-credentials__miniapp_cell">
      <view border slot='title' class="es-credentials__name-box">
        <text class="es-credentials__required-text" wx:if="{{isRequiredShow}}">*</text>
        证件类型
      </view>
      <view class='es-credentials__type-select'>
        <view wx:class="{{disabledBBB}}" class='es-credentials__type-text' bindtap="showTypeSelect">
          {{cardType.card_name}}
          <text wx:if="{{cardType.card_name}}" class="es-credentials__type-tag">证件</text>
        </view>
        <text wx:if="{{!isIdTypeDisable}}" class="es-credentials__type-change" bindtap="showTypeSelect">更换证件</text>
      </view>
    </es-cell>

    <!-- 证件号码 -->
    <es-cell border useTitle custom-class="es-credentials__miniapp_cell" wx:ref="abcd">
      <view border slot='title' class="es-credentials__name-box">
        <text class="es-credentials__required-text" wx:if="{{isRequiredShow}}">*</text>
        证件号码
      </view>
      <es-field
        wx:class="{{disabled333}}"
        disabled="{{isIdNoDisable}}"
        placeholder='请与证件保持一致'
        wx:model="{{id_no}}"
        bind:input="handleCardNoInput"
        bind:focus="cardNoFocus"
        bind:blur="cardBlur"
      />
    </es-cell>

    <!-- 证件有效期  安全整改去掉-->
    <es-cell border useTitle wx:if="{{isCardExpiredShow}}" custom-class="es-credentials__miniapp_cell">
      <view border slot='title' class='es-credentials__type es-credentials__name-box'>
        <text class="es-credentials__required-text" wx:if="{{isRequiredShow}}">*</text>
        证件有效期
      </view>
      <picker mode="date" value="{{expire_date}}" start="{{startDate}}" end="2099-12-31" bindchange="showCardExpire">
        <!-- <es-field placeholder='请选择证件有效期' value="{{expire_date}}" /> -->
        <view wx:if="{{expire_date !== ''}}">{{expire_date}}</view>
        <view wx:else class="placeholder">请选择证件有效期</view>
      </picker>
      <view border slot='icon-right'>
        <es-icon name='angle-right' size="16" color="#999999"></es-icon>
      </view>
    </es-cell>

    <drawer-bottom show="{{isCardTypeShow}}" bind:close="showTypeSelect">
      <view border slot='header'>
        <view class="es-credentials__drawer-header">
          <view class="es-credentials__drawer-header-title">请选择证件类型</view>
          <view class="es-credentials__drawer-header-right" bindtap="showTypeSelect">
            <es-icon class="es-credentials__drawer-close" size="24" color="#999999" name="close-filled"></es-icon>
          </view>
        </view>
      </view>
      <view wx:for="{{availableCardTypeList}}">
        <es-cell 
          border
          useTitle
          custom-class="es-credentials__miniapp_drawer_cell" 
          class="es-cell-custom" 
          wx:if="{{item.code != cardType.code}}" 
          bind:click="selectCardType(item)" 
        >
          <view slot='title'>
            <text>{{item.name}}</text>
            <text class="es-credentials__card-no" wx:if="{{item.display_card_no}}">{{item.display_card_no}}</text>
          </view>
        </es-cell>
        <es-cell 
          border 
          useTitle
          custom-class="es-credentials__miniapp_drawer_cell" 
          class="es-cell-custom" 
          wx:else 
          align='right' 
          bind:click="showTypeSelect"
        >
          <view slot='title'>
            <text>{{item.name}}</text>
            <text class="es-credentials__card-no" wx:if="{{item.display_card_no}}">{{item.display_card_no}}</text>
          </view>
          <es-icon class="es-credentials__checked" name='check-filled'></es-icon>
        </es-cell>
      </view>
      <view style="height:80px;width:100%"/>   
    </drawer-bottom>

    <!-- 选择证件有效期弹窗 -->
    <!-- <drawer-bottom  
      title="请选择证件有效期"
      show="{{isCardExpireShow}}"
      @close="showCardExpire"
      class="es-credentials__drawer"
    >
      <view class="es-credentials__drawer-content">
        <es-date-time 
          type="date" 
          wx:model="{{expire_date_model}}" 
          minDate="{{startDate}}"
          maxDate="2099-12-31"
          formatter="{{formatter}}" 
        />
        <view class="es-credentials__drawer-footer">
          <es-button block type="info" bind:click="saveExpiredDate">确认</es-button>
        </view>
      </view>
    </drawer-bottom> -->
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import { formatDate } from '@didi/es-mpx-shared'
  import { AES_ECB_DECRYPT, AES_ECB_ENCRYPT } from '@/common/crypto'
  import { cloneDeep } from 'lodash'
  import store from '@/store'
  import { is } from '@didi/webx-js'
  import { hasRequired } from '@/utils'

  createComponent({
    data: {
      isCardTypeShow: false,
      isCardExpireShow: false,
      startDate: formatDate(),
      id_no: '',
      expire_date: '',
      isChange: false,
      isCardExpiredShow: false
    },

    pageLifetimes: {
      show: function () {
        this.$forceUpdate()
      }
    },

    props: {
      isAddPage: {
        type: Boolean,
        value: true
      },
      secretKey: {
        type: String,
        value: ''
      },
      cardType: {
        type: Object,
        value: {}
      },
      cardTypeList: {
        type: Array,
        value: []
      },
      expireDateConfig: {
        type: Object,
        value: {}
      },
      isRequiredShow: {
        type: Boolean,
        value: true
      },
      isCanDelete: {
        type: Boolean,
        value: true
      },
      aesOriginCardList: {
        type: Array,
        value: []
      },
      isIdTypeDisable: {
        type: Boolean,
        value: true
      },
      isIdNoDisable: {
        type: Boolean,
        value: true
      },
    },

    computed: {
      ...store.mapState({
        contactDetail: 'newContacts.contactDetail'
      }),
      ...store.mapGetters({
        isExemption: 'makeOrder.isExemption',
      }),
      disabledStyle() {
        const userStatus = +this.contactDetail?.list?.user_status
        return !this.isAddPage && userStatus === 1 && !this.isExemption
      },
      disabledBBB() {
        return this.disabledStyle ? 'disabled-bbb' : ''
      },
      disabled333() {
        return this.disabledStyle ? is('android') ? 'disabled-bbb' : 'disabled-333' : ''
      },
      availableCardTypeList() {
        let res = cloneDeep(this.cardTypeList)
        if (res.findIndex((item) => item.card_type == this.cardType?.card_type) === -1) {
          // res.push(this.cardType)
          res = res.sort((a, b) => {
            return a.card_type - b.card_type
          })
        }
        res?.forEach((item) => {
          const index = this.aesOriginCardList.findIndex((val) => val.card_type == item.card_type)
          if (index !== -1) {
            item.display_card_no = this.aesOriginCardList[index].id_no
          }
        })
        return res
      }
    },

    watch: {
      cardType: {
        immediate: true,
        handler(item) {
          const userStatus = +this.contactDetail?.list?.user_status
          this.isChange = item?.isChange
          this.isCardExpiredShow = hasRequired(
            this.expireDateConfig?.requiredcCrdTypes || [],
            [item],
            this.expireDateConfig?.isRequired,
            true
          ) && (this.isAddPage || this.isExemption ? true : userStatus !== 1 )
          // 运营商拿不到证件有效期的数据, 遂在编辑态, 乘车人核验通过的情况下不展示该表单项
          if (item && item.expire_date) {
            const reg = /^\d{4}\-\d{2}\-\d{2}$/
            if (!reg.test(item.expire_date)) {
              this.expire_date = AES_ECB_DECRYPT(item.expire_date)
            } else {
              this.expire_date = item.expire_date
            }
          }
        }
      }
    },

    mounted() {
      this.initIdNo()
    },

    methods: {
      // 回弹逻辑
      requestAnimation() {
        const content = document.getElementsByClassName('es-content')?.[0]
        const height = parseInt(content.style.minHeight)
        content.style.minHeight = `${height - 2}%`
        if (height >= 100) window.requestAnimationFrame(this.requestAnimation)
      },
      // 失焦事件
      cardBlur() {
        if (is('android')) {
          window.requestAnimationFrame(this.requestAnimation)
        }
      },
      //证件号码输入框聚焦
      cardNoFocus() {
        if (is('android')) {
          const content = document.getElementsByClassName('es-content')?.[0]
          const credentials = document.getElementsByClassName('es-credentials')?.[0]
          // 获取焦点时设置 minHeight 避免安卓键盘覆盖页面
          content.style.minHeight = '125%'
          // 平滑滚动
          credentials.scrollIntoView({
            block: 'start',
            behavior: 'smooth'
          })
        }
        if (this.isChange) {
          return
        }
        this.isChange = true
        this.id_no = ''
        this.$trigger('input-change', {
          value: '',
          isChange: this.isChange,
          card_type: this.cardType?.code
        })
        this.$trigger('expired-date-change', {
          value: '',
          card_type: this.cardType?.code
        })
      },
      // 证件类型弹窗
      showTypeSelect(e) {
        if(this.isIdTypeDisable) return
        // h5 让所有的输入框失去焦点
        if (__mpx_mode__ === 'web') {
          document.querySelectorAll('input')?.forEach((item) => {
            item.blur()
          })
        }

        this.$nextTick(() => {
          setTimeout(() => {
            this.isCardTypeShow = !this.isCardTypeShow
          }, 250)
        })

        if (e && e.detail && e.stopPropagation && e.preventDefault) {
          e.stopPropagation()
          e.preventDefault(true)
        }
      },
      // 证件类型弹窗
      showCardExpire(e) {
        // this.isCardExpireShow = !this.isCardExpireShow;
        this.expire_date = e.detail.value

        this.$trigger('expired-date-change', {
          value: e.detail.value,
          card_type: this.cardType?.card_type
        })
      },

      // 切换证件类型
      selectCardType(item) {
        this.id_no = ''
        this.expire_date = ''
        this.$trigger('change-item', {
          origin: this.cardType,
          target: { ...item, card_name: item.name, card_type: item.code }
        })
        this.showTypeSelect()
      },
      // 删除证件类型
      deleteCardType() {
        this.id_no = ''
        this.expire_date = ''
        this.cardType['id_no'] = ''
        this.cardType['expire_date'] = ''
        this.cardType['secret_card_no'] = ''
        this.$trigger('delete-item', this.cardType)
      },
      // 证件号码输入
      handleCardNoInput(e) {
        this.$trigger('input-change', {
          value: e.detail.value,
          card_type: this.cardType?.card_type
        })
      },
      // 证件有效期选择
      saveExpiredDate() {
        // this.expire_date = formatDate(this.expire_date_model);
        // this.$trigger('expired-date-change', {
        //   value: formatDate(this.expire_date_model),
        //   card_type: this.cardType.card_type
        // });
        // this.isCardExpireShow = false;
      },
      // 初始化证件号码
      initIdNo() {
        this.id_no = this.isAddPage ? '' : this.contactDetail?.list?.encrypt_id_no
      },
      formatter(val, type) {
        const res = val.map((ele) => {
          if (type === 'year') {
            ele += '年'
          } else if (type === 'month') {
            ele += '月'
          } else if (type === 'day') {
            ele += '日'
          }
          return ele
        })
        return res
      }
    }
  })
</script>

<style lang='stylus' scoped>
  .placeholder
    color #999999 !important
  .disabled-333
    color #333
  .disabled-bbb
    color #bbb
  +b('credentials')
    margin-bottom 16px
    /deep/ .placeholder
      color #999999 !important
    +e('type')
      display flex
    +e('type-select')
      display flex
      /deep/ .delete
        font-size 20px !important
        color #999999 !important
        padding-left 12px
    // 小程序用
    +e('miniapp_cell')
      height 54px
      color #333333
      padding 10px 0 !important
      &::after
        border-bottom 1px solid #f0f2f7
        left 90px !important
        right 0 !important
    // 小程序用
    +e('miniapp_drawer_cell')
      padding 10px 0 !important
      &::after
        border-bottom 1px solid #eeeeee !important
        left 0 !important
        right 0 !important
    +e('type-text')
      flex 1
      display flex
    +e('type-tag')
      color #1473ff
      border 1px solid #73ACFF
      border-radius 2px
      margin-left 4px
      display inline-block
      line-height 1
      font-size 12px
      padding 2px
      transform scale(0.83)
      align-self center
      white-space nowrap
    +e('type-change')
      color #1473FF
      font-size 12px
      display inline-block
      transform scale(0.9)
      align-self center
    +e('checked')
      color #1473ff
      font-size 20px
    +e('drawer')
      /deep/ .drawer-container
        height auto
      /deep/ .drawer-main
        height auto
    +e('drawer-content')
      display flex
      flex-direction column
    +e('drawer-footer')
      padding 16px 0
      background-color #ffffff
      /deep/ .es-button
        border-radius 8px
    +e('drawer-header')
      display flex
      height 60px
      border-bottom 1px solid #eeeeee
      align-items center
    +e('drawer-header-title')
      flex 1
      text-align center
      font-size 16px
      font-weight 500
      margin-left 56px
    +e('drawer-header-right')
      width 56px
      text-align center
    +e('drawer-header-close')
      color #999999 !important
    +e('required-text')
      color #F93822
    +e('card-no')
      margin-left 8px
    +e('name-box')
      display flex
      width 88px
      margin-right 9px
</style>

<script name='json'>
  module.exports = {
    component: true,
    usingComponents: {
      'es-button': '@didi/es-mpx-ui/lib/button',
      'es-cell': '@didi/es-mpx-ui/lib/cell',
      'es-field': '@didi/es-mpx-ui/lib/field',
      'es-icon': '@didi/es-mpx-ui/lib/icon',
      'drawer-bottom': '../drawer-bottom',
      'es-date-time': '@didi/es-mpx-ui/lib/picker/datetime'
    }
  }
</script>

